import { DocumentNode, gql } from '@apollo/client'

export const GET_SUGGEST_PARENTS: DocumentNode = gql`
    query getSuggestParents(
        $daycareId: Int!
        $isNanny: Boolean!
        $country: String
        $city: String
        $range: Int
        $minMonth: Int
        $maxMonth: Int
    ) {
        getSuggestParents(
            daycareId: $daycareId
            isNanny: $isNanny
            country: $country
            city: $city
            range: $range
            minMonth: $minMonth
            maxMonth: $maxMonth
        ) {
            parent {
                id
                userId
                email
                firstname
                lastname
                phone
                phoneSecond
                address
                city
                zip
                country
                addressSecond
                citySecond
                zipSecond
                countrySecond
                notifReminderMail
                notifReminderPush
                notifBookingMail
                notifBookingPush
                notifEventMail
                notifEventPush
                notifNewPostPush
                notifTaskNote
                notifTaskNotePush
                enrolment
                daycareRegistered
                created
                isNanny
                childs {
                    id
                    firstname
                    birthdate
                    daycares {
                        daycareId
                        sections {
                            sectionId
                            sectionName
                            isPrimary
                        }
                        group {
                            groupId
                            groupName
                        }
                        complement
                        request
                        visible
                    }
                }
                daycares {
                    daycareId
                    daycareName
                    daycareCity
                    isRpeOrLaep
                    childs {
                        childId
                        firstname
                        birthdate
                        complement
                        request
                        preference {
                            mon
                            tue
                            wed
                            thu
                            fri
                            sat
                            sun
                        }
                    }
                }
            }
            internalNote
            liked
            disliked
        }
    }
`

export const GET_SUGGEST_STAFFS: DocumentNode = gql`
    query getSuggestStaffs($daycareId: Int!, $country: String, $city: String, $range: Int) {
        getSuggestStaffs(daycareId: $daycareId, country: $country, city: $city, range: $range) {
            staff {
                id
                userId
                email
                firstname
                lastname
                phone
                address
                city
                zip
                country
            }
            internalNote
            liked
            disliked
        }
    }
`

export const SET_LIKE_SUGGEST: DocumentNode = gql`
    mutation setLikeSuggest($userId: Int!, $daycareId: Int!, $liked: Boolean!) {
        setLikeSuggest(userId: $userId, daycareId: $daycareId, liked: $liked)
    }
`

export const SET_INTERNAL_NOTE_SUGGEST: DocumentNode = gql`
    mutation setInternalNoteSuggest($userId: Int!, $daycareId: Int!, $internalNote: String!) {
        setInternalNoteSuggest(userId: $userId, daycareId: $daycareId, internalNote: $internalNote)
    }
`

export const SET_DISLIKE_SUGGEST: DocumentNode = gql`
    mutation setDislikeSuggest($userId: Int!, $daycareId: Int!, $disliked: Boolean!) {
        setDislikeSuggest(userId: $userId, daycareId: $daycareId, disliked: $disliked)
    }
`

export const GET_DISLIKED_SUGGEST_PARENTS: DocumentNode = gql`
    query getDislikedSuggestParents($daycareId: Int!, $isNanny: Boolean!) {
        getDislikedSuggestParents(daycareId: $daycareId, isNanny: $isNanny) {
            parent {
                id
                userId
                email
                firstname
                lastname
                phone
                address
                city
                zip
                country
                childs {
                    id
                    firstname
                    birthdate
                    daycares {
                        daycareId
                        sections {
                            sectionId
                            sectionName
                            isPrimary
                        }
                    }
                }
                daycares {
                    daycareId
                    daycareName
                    daycareCity
                    isRpeOrLaep
                    childs {
                        childId
                        firstname
                        birthdate
                    }
                }
            }
            internalNote
            liked
            disliked
        }
    }
`

export const GET_DISLIKED_SUGGEST_STAFFS: DocumentNode = gql`
    query getDislikedSuggestStaffs($daycareId: Int!) {
        getDislikedSuggestStaffs(daycareId: $daycareId) {
            staff {
                id
                userId
                email
                firstname
                lastname
                phone
                address
                city
                zip
                country
            }
            internalNote
            liked
            disliked
        }
    }
`
